<template>
  <div id="device-bg-main">
    <timer />
    <list-projects-page v-if="getWorker" />
  </div>
</template>

<script>
import ListProjectsPage from '../components/ListProjectsPage.vue';
import timer from '../components/Timer.vue';
export default {
  name: 'Home',
  components: {
    ListProjectsPage,
    timer,
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!vm.$store.getters.getWorker) {
        next(false);
        vm.$router.push({ name: 'DeviceCheckInCheckOut' });
      } else {
        next();
      }
    });
  },
  computed: {
    getWorker () {
      return this.$store.getters.getWorker;
    },
  },
};
</script>
